(() => {
  'use strict';

  const lang = (document.documentElement.lang || 'en').toLowerCase().split('-')[0];
  const root = window.Shopify?.routes?.root || '/';
  const copy = {
    en:{pay:'Pay securely', preparing:'Preparing VIP access…', error:'We could not prepare your VIP access. Please try again.'},
    nl:{pay:'Veilig betalen', preparing:'VIP-toegang voorbereiden…', error:'We konden je VIP-toegang niet voorbereiden. Probeer het opnieuw.'},
    de:{pay:'Sicher bezahlen', preparing:'VIP-Zugang wird vorbereitet…', error:'Der VIP-Zugang konnte nicht vorbereitet werden. Bitte erneut versuchen.'},
    fr:{pay:'Paiement sécurisé', preparing:'Préparation de votre accès VIP…', error:'Impossible de préparer votre accès VIP. Veuillez réessayer.'},
    fa:{pay:'پرداخت امن', preparing:'در حال آماده‌سازی دسترسی VIP…', error:'دسترسی VIP آماده نشد. لطفاً دوباره تلاش کنید.'},
    ar:{pay:'دفع آمن', preparing:'جارٍ تجهيز وصول VIP…', error:'تعذر تجهيز وصول VIP. يرجى المحاولة مرة أخرى.'}
  }[lang] || {pay:'Pay securely', preparing:'Preparing VIP access…', error:'We could not prepare your VIP access. Please try again.'};

  const rowVariantIds = [
    '48512420348162',
    '48512420544770',
    '48512420380930',
    '48512420413698',
    '48512420446466',
    '48512420479234',
    '48512420577538',
    '48512407372034',
    '48512407404802',
    '48512407437570'
  ];

  const packageVariantIds = {
    silver:'48512407372034',
    gold:'48512407404802',
    diamond:'48512407437570'
  };

  const detailVariantIds = {
    'supplement-schema':'48512420348162',
    'training-schema':'48512420380930',
    'diet-schema':'48512420413698',
    'silver-training-nutrition':'48512407372034',
    'gold-training-nutrition-supplements':'48512407404802',
    'diamond-complete-coaching':'48512407437570'
  };

  const accessByVariant = {
    '48512420348162': {modules:['supplements'], days:0, mode:'plan-end'},
    '48512420544770': {modules:['training'], days:0, mode:'pt-session'},
    '48512420380930': {modules:['training'], days:30, mode:'fixed-days'},
    '48512420413698': {modules:['nutrition'], days:30, mode:'fixed-days'},
    '48512420446466': {modules:['training','nutrition'], days:30, mode:'fixed-days'},
    '48512420479234': {modules:['training','nutrition','supplements'], days:30, mode:'fixed-days'},
    '48512420577538': {modules:['training','nutrition','supplements'], days:30, mode:'fixed-days'},
    '48512407372034': {modules:['training','nutrition'], days:0, mode:'package-end'},
    '48512407404802': {modules:['training','nutrition','supplements'], days:0, mode:'package-end'},
    '48512407437570': {modules:['training','nutrition','supplements'], days:0, mode:'package-end'}
  };

  const generateVipCode = (variantId) => {
    const key = `mbf-vip-code:${variantId}`;
    try {
      const existing = sessionStorage.getItem(key);
      if (existing) return existing;
      const bytes = new Uint8Array(6);
      crypto.getRandomValues(bytes);
      const hex = [...bytes].map(v => v.toString(16).padStart(2,'0')).join('').toUpperCase();
      const code = `MBF-${hex.slice(0,4)}-${hex.slice(4,8)}-${hex.slice(8,12)}`;
      sessionStorage.setItem(key, code);
      return code;
    } catch (_) {
      const fallback = Math.random().toString(36).slice(2,14).toUpperCase();
      return `MBF-${fallback.slice(0,4)}-${fallback.slice(4,8)}-${fallback.slice(8,12)}`;
    }
  };

  const prepareVipCheckout = async (anchor, variantId) => {
    if (anchor.dataset.mbfBusy === '1') return;
    const access = accessByVariant[variantId];
    if (!access) return;

    anchor.dataset.mbfBusy = '1';
    anchor.setAttribute('aria-busy','true');
    const original = anchor.textContent;
    anchor.textContent = copy.preparing;

    const code = generateVipCode(variantId);
    try {
      const response = await fetch(`${root}cart/add.js`, {
        method:'POST',
        headers:{'Content-Type':'application/json','Accept':'application/json'},
        body:JSON.stringify({
          items:[{
            id:Number(variantId),
            quantity:1,
            properties:{
              'MBF VIP Code':code,
              '_MBF Modules':access.modules.join(','),
              '_MBF Access Days':String(access.days),
              '_MBF Access Mode':access.mode,
              '_MBF Access Version':'1'
            }
          }]
        })
      });
      if (!response.ok) throw new Error(`cart/add ${response.status}`);
      window.location.assign(`${root}checkout`);
    } catch (error) {
      console.error('[MBF VIP checkout]', error);
      anchor.dataset.mbfBusy = '0';
      anchor.removeAttribute('aria-busy');
      anchor.textContent = original;
      window.alert(copy.error);
    }
  };

  const bindCheckout = (anchor, variantId) => {
    anchor.href = '#';
    anchor.dataset.mbfServiceCheckout = variantId;
    anchor.dataset.mbfVip = '1';
    anchor.addEventListener('click', (event) => {
      event.preventDefault();
      prepareVipCheckout(anchor, variantId);
    });
  };

  const addPayLink = (host, variantId, extraClass = '') => {
    if (!host || !variantId || host.querySelector('.mbf-service-pay')) return;
    const a = document.createElement('a');
    a.className = `mbf-service-pay ${extraClass}`.trim();
    a.textContent = `${copy.pay} →`;
    a.setAttribute('role','button');
    bindCheckout(a, variantId);
    host.appendChild(a);
  };

  const unlockedVault = document.querySelector('.pt-vault:not(.pt-vault--locked)');
  if (unlockedVault) {
    unlockedVault.querySelectorAll('.pt-price-row').forEach((row, index) => {
      addPayLink(row, rowVariantIds[index], 'mbf-service-pay--row');
    });

    Object.entries(packageVariantIds).forEach(([tier, id]) => {
      const actions = document.querySelector(`.ptl-package--${tier} .ptl-package__actions`);
      addPayLink(actions, id, 'mbf-service-pay--package');
    });
  }

  const handle = window.location.pathname.split('/').filter(Boolean).pop() || '';
  const detailId = detailVariantIds[handle];
  const detailPriceUnlocked = !!document.querySelector('.pt-detail-price-gate strong');
  if (detailId && detailPriceUnlocked) {
    const actions = document.querySelector('.pt-detail-hero .hero-actions');
    if (actions && !actions.querySelector('.mbf-service-pay')) {
      const a = document.createElement('a');
      a.className = 'button button--accent mbf-service-pay mbf-service-pay--detail';
      a.textContent = `${copy.pay} →`;
      a.setAttribute('role','button');
      bindCheckout(a, detailId);
      actions.prepend(a);
    }
  }

  const style = document.createElement('style');
  style.textContent = `
    .pt-vault:not(.pt-vault--locked) .pt-price-row{grid-template-columns:minmax(220px,1.18fr) minmax(120px,.38fr) minmax(160px,.5fr) auto}
    .mbf-service-pay{display:inline-flex;align-items:center;justify-content:center;min-height:42px;padding:10px 15px;border:1px solid rgba(255,255,255,.22);background:#fff;color:#111!important;text-decoration:none!important;font-size:10px;font-weight:900;letter-spacing:.075em;text-transform:uppercase;white-space:nowrap;transition:transform .2s ease,background .2s ease,border-color .2s ease,opacity .2s ease;cursor:pointer}
    .mbf-service-pay:hover{transform:translateY(-2px);background:#ff4b2b;color:#fff!important;border-color:#ff4b2b}
    .mbf-service-pay--package{background:#ff4b2b;color:#fff!important;border-color:#ff4b2b}
    .mbf-service-pay--detail{background:#fff!important;color:#111!important}
    .mbf-service-pay[aria-busy='true']{opacity:.65;pointer-events:none}
    @media(max-width:900px){.pt-vault:not(.pt-vault--locked) .pt-price-row{grid-template-columns:minmax(0,1fr) auto}.pt-vault:not(.pt-vault--locked) .pt-price-row__value{grid-column:1/-1}.pt-vault:not(.pt-vault--locked) .mbf-service-pay--row{grid-column:1/-1;width:100%;margin-top:2px}}
  `;
  document.head.appendChild(style);
})();
